import { GetStaticPropsContext } from 'next';

import { PageCategory } from '~/features/analytics/constants';
import { GovernmentFooterBanner } from '~/features/government/components/government-footer-banner';
import { GovernmentHero } from '~/features/government/components/government-hero';
import { GovernmentImpactDrivenSolutions } from '~/features/government/components/government-impact-driven-solutions';
import { GovernmentImpactInfluence } from '~/features/government/components/government-impact-influence';
import { GovernmentSocietalImpact } from '~/features/government/components/government-societal-impact';
import { GovernmentSuccessStories } from '~/features/government/components/government-success-stories';
import { GovernmentTestimonials } from '~/features/government/components/government-testimonials';
import { GovernmentTopPrograms } from '~/features/government/components/government-top-programs';
import {
  governmentFooterBannerBackgroundImages,
  governmentFooterBannerContent,
} from '~/features/government/configs/footer-banner-content';
import { DEFAULT_LANGUAGE } from '~/features/internationalization/languages';
import { PageHead } from '~/features/page/components/page-head';
import { PageLayout } from '~/features/page/components/page-layout';
import { getPage } from '~/features/page/controllers/get-page';
import { Page } from '~/features/page/models/page';
import { popularCatalogItems } from '~/features/page-template/templates/home/model/recommendations';
import { useScrollDepthEvent } from '~/hooks/use-scroll-depth-event';

export default function GovernmentOverviewPage({ page }: { page: Page }) {
  // Scroll depth is ungated here (not behind the `dino` flag) because this page
  // is low-traffic, so we want full coverage rather than an experiment segment.
  useScrollDepthEvent({
    threshold: [25, 50, 75, 99],
    analyticsProperties: {
      category: PageCategory.Government,
    },
  });

  return (
    <>
      <PageHead page={page} />
      <PageLayout withoutVerticalPadding>
        {/* TODO(CONENG-2261): new layout */}
        <GovernmentHero />
        <GovernmentImpactDrivenSolutions />
        <GovernmentTestimonials />
        <GovernmentImpactInfluence />
        <GovernmentSocietalImpact />
        <GovernmentSuccessStories />
        <GovernmentTopPrograms catalogItems={popularCatalogItems} />
        <GovernmentFooterBanner
          backgroundImages={governmentFooterBannerBackgroundImages}
          description={governmentFooterBannerContent.description}
          heading={governmentFooterBannerContent.heading}
          primaryButtonLabel={governmentFooterBannerContent.primaryButtonLabel}
        />
      </PageLayout>
    </>
  );
}

export async function getStaticProps({ locale }: GetStaticPropsContext) {
  if (locale !== DEFAULT_LANGUAGE) {
    return { notFound: true };
  }

  const page = await getPage('/government/overview');

  return {
    props: { page },
  };
}
